var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quantity-inner"},[_c('div',{staticClass:"quantity-less"},[(_vm.quantity == 1)?_c('span',{staticClass:"icon-bin"}):_c('span',{staticClass:"icon-minus"})]),_c('div',{staticClass:"quantity-value"},[_vm._v(" "+_vm._s(_vm.quantity)+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quantity-add"},[_c('span',{staticClass:"icon-plus"})])
}]

export { render, staticRenderFns }